// @flow
import * as React from "react"
import { FormattedMessage } from "react-intl"
import { connect } from "react-redux"
import { TweenMax, Cubic } from "gsap"
import { currentLocale, setLocale, LOCALE_EN, LOCALE_ES } from "../../Intl"
import { setModal } from "../../Modal"
import type { Match, RouterHistory } from "react-router-dom"
import type { Locale, SetLocale } from "../../Intl"
import type { SetModal } from "../../Modal"

import {
  Container,
  Modal,
  Content,
  ConfirmBody,
  Header,
  PrimaryHeading,
  SecondaryHeading,
  PrimaryButton,
  ButtonGroup,
  Fade
} from "../Modal"

type Props = {
  match: Match,
  history: RouterHistory,
  currentLocale: Locale,
  setLocale: SetLocale,
  setModal: SetModal
}

class LanguageModal extends React.Component<Props> {
  body: ?HTMLElement
  fade: ?HTMLElement

  constructor(props) {
    super(props)
    this.body = null
    this.fade = null
  }

  componentDidMount = () => {
    TweenMax.set(this.body, { y: "-=50", opacity: 0 })
    TweenMax.set(this.fade, { opacity: 0 })
    TweenMax.to(this.body, 0.5, { ease: Cubic.easeOut, opacity: 1, y: 0 })
    TweenMax.to(this.fade, 0.5, { ease: Cubic.easeOut, opacity: 1 })
  }

  handleCancel = () => {
    this.dismiss()
  }

  handleConfirm = () => {
    const { currentLocale, setLocale } = this.props
    setLocale(currentLocale === LOCALE_EN ? LOCALE_ES : LOCALE_EN)
    this.dismiss()
  }

  dismiss = () => {
    const { history, setModal } = this.props
    setModal(false)
    TweenMax.to(this.body, 0.5, { ease: Cubic.easeOut, opacity: 0, y: "+=50" })
    TweenMax.to(this.fade, 0.5, {
      ease: Cubic.easeOut,
      opacity: 0,
      onComplete: () => {
        history.goBack()
      }
    })
  }

  render() {
    return (
      <Container>
        <Fade
          onClick={() => this.handleCancel()}
          dark
          innerRef={el => (this.fade = el)}
        />
        <Modal>
          <ConfirmBody innerRef={el => (this.body = el)}>
            <Header>
              <PrimaryHeading>
                <FormattedMessage id="kiosk.language.title" />
              </PrimaryHeading>
              <SecondaryHeading>
                <FormattedMessage id="kiosk.language.subtitle" />
              </SecondaryHeading>
            </Header>
            <Content>
              <ButtonGroup>
                <PrimaryButton onClick={this.handleCancel}>
                  <FormattedMessage id="kiosk.language.cancel" />
                </PrimaryButton>
                <PrimaryButton onClick={this.handleConfirm}>
                  <FormattedMessage id="kiosk.language.confirm" />
                </PrimaryButton>
              </ButtonGroup>
            </Content>
          </ConfirmBody>
        </Modal>
      </Container>
    )
  }
}

export default connect(state => ({ currentLocale: currentLocale(state) }), {
  setLocale,
  setModal
})(LanguageModal)



// WEBPACK FOOTER //
// ./src/Kiosk/LanguageModal/LanguageModal.js